import { useState, useEffect } from 'react';
import axios from 'axios';

import { BASE_URL as API } from '../App';

export default function Footer({ variant = 'default' }) {
  const [footerContent, setFooterContent] = useState('');
  const [footerEnabled, setFooterEnabled] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchFooterSettings();
  }, []);

  const fetchFooterSettings = async () => {
    try {
      const response = await axios.get(`${API}/api/settings/footer`);
      setFooterContent(response.data.content || '');
      setFooterEnabled(response.data.enabled !== false);
    } catch (error) {
      // Silently fail - footer is not critical
      console.error('Failed to fetch footer settings:', error);
      setFooterContent('');
    } finally {
      setIsLoading(false);
    }
  };

  // Don't render if disabled (but always render if loading to maintain layout)
  if (!isLoading && (!footerEnabled || !footerContent)) {
    return null;
  }

  // Dark variant for login and dark-themed pages
  if (variant === 'dark') {
    return (
      <footer className="text-center py-4 text-xs text-slate-400 border-t border-slate-800 shrink-0">
        <div dangerouslySetInnerHTML={{ __html: footerContent || '&nbsp;' }} />
      </footer>
    );
  }

  return (
    <footer className="bg-white/80 backdrop-blur-sm border-t border-gray-200 shrink-0">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div
          className="text-center text-sm text-gray-600"
          dangerouslySetInnerHTML={{ __html: footerContent || '&nbsp;' }}
        />
      </div>
    </footer>
  );
}
